import React, { useReducer, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Modal, Tooltip, message, Input } from 'antd';
import SelectInput from 'src/components/shared/selectInput';
import { useSelector } from 'react-redux';
import apiCalls from 'src/api/apiCalls';
import { uuidv4 } from 'src/utils/constantsErrMsgs';
import Loader from 'src/components/loader.component';
import ErrorMessage from 'src/components/shared/messages/errorMessage';
import { getAdmins, getCaseDetails, getTemplates, deleteCaseAssigners } from './service';
import { casesReducer, initialState } from './reducer';
import apicallsForCases from './api';
import CaseInfo from './info';
import AuditLogDetails from './auditLogDetails';
import Details from './caseDetails';
import HeaderComponent from '../header';
import { validateContentRules } from 'src/utils/custom.validator';
import { isErrorMessage } from '../shared/error.message';
const { confirm } = Modal;
const { TextArea } = Input;
const Edit = () => {
    const userProfile = useSelector(store => store.oidc?.user)
    const [state, dispatch] = useReducer(casesReducer, initialState);
    const { id, screen, caseState } = useParams();
    const { caseDetails, caseStateLu, adminsData, templateLU, loader, isDeleteRecord, isDeleted, error, caseStateSelect } = state;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const handleCancel = useCallback(() => {
        navigate(`/cases/casesgrid`)
    }, [navigate])
    useEffect(() => {
        if (id) {
            fetchCaseDetails(id);
        }
    }, [id]);
    useEffect(() => {
        if (screen && caseState) {
            fetchCaseStateLu(caseState);
        }
    }, [screen, caseState]);
    const breadCrumbList = [
        { id: '1', bname: 'Cases', url: `/cases/casesgrid` },
        { id: '2', bname: caseDetails?.caseNumber }
    ];
    const addRow = async (add) => {
        if (isDeleteRecord) {
            dispatch({ type: 'SET_IS_DELETED_RECORD', payload: false });
        } else {
            dispatch({ type: 'SET_IS_DELETED_RECORD', payload: true });
        }
        const res = await getAdmins();
        dispatch({ type: 'SET_ADMINS_DATA', payload: res.data });
        add();
    }
    const deleteRow = async (id, remove) => {
        try {
            dispatch({ type: 'SET_IS_DELETED', payload: true });
            const res = await getAdmins();
            dispatch({ type: 'SET_ADMINS_DATA', payload: res.data });
            let deleteId = caseDetails?.assignedTo[id]?.id;
            caseDetails.assignedTo.splice(id, 1);
            if (deleteId) {
                const response = await deleteCaseAssigners(deleteId);
                if (response) {
                    dispatch({ type: 'SET_IS_DELETED', payload: false });
                    remove(id);
                    message.success("Assigned details deleted successfully");
                } else {
                    dispatch({ type: 'SET_ERROR', payload: isErrorMessage(response.data) });
                    dispatch({ type: 'SET_IS_DELETED', payload: false });
                }
            } else {
                remove(id);
                dispatch({ type: 'SET_IS_DELETED', payload: false });
            }
        } catch (error) {
            dispatch({ type: 'SET_IS_DELETED', payload: false });
            dispatch({ type: 'SET_ERROR', payload: apiCalls.isErrorDispaly(error.message) });
        }
    };
    const fetchCaseStateLu = async (state) => {
        try {
            const stateLu = await apiCalls.getStateChangeLu(state);
            dispatch({ type: 'SET_CASE_STATE_LU', payload: stateLu?.data });
        } catch (error) {
            dispatch({ type: 'SET_ERROR', payload: apiCalls.isErrorDispaly(error.message) });
        }
    };
    const fetchCaseDetails = async (id) => {
        dispatch({ type: 'SET_LOADER', payload: true });
        dispatch({ type: 'SET_ERROR', payload: null });
        try {
            const [caseRes, assignedToRes, templateRes] = await Promise.all([getCaseDetails(id), getAdmins(), getTemplates()]);
            let obj = caseRes.data;
            obj.assignedTo = caseRes.data?.assignedTo?.map?.((item) => ({
                ...item,
                assignedToIds: item.assignedToIds?.split(",")
            }));
            form.setFieldsValue(obj);
            dispatch({ type: 'SET_CASE_DETAILS', payload: obj });
            dispatch({ type: 'SET_CASE_STATE', payload: obj.state });
            dispatch({ type: 'SET_ADMINS_DATA', payload: assignedToRes.data });
            dispatch({ type: 'SET_TEMPLATE_LU', payload: templateRes.data });
            dispatch({
                type: 'SET_BREADCRUMB', payload: [
                    { id: '1', bname: 'Cases', url: "/cases/casesgrid" },
                    { id: '2', bname: caseRes.data?.caseNumber }
                ]
            });
            dispatch({ type: 'UPDATE_DOCUMENTS', payload: obj.caseDetails });
        } catch (error) {
            dispatch({ type: 'SET_ERROR', payload: apiCalls.isErrorDispaly(error.message) });
        }
        finally {
            dispatch({ type: 'SET_LOADER', payload: false });
        }
    };
    const handleCheckboxChange = (documentId) => {
        const updatedDocuments = state?.updatedDocuments?.map?.((document) => {
            if (document.id === documentId) {
                return { ...document, isChecked: !document.isChecked };
            }
            return document;
        });
        dispatch({
            type: 'UPDATE_DOCUMENTS',
            payload: updatedDocuments,
        });
    };
    const handleToggle = (e) => {
        const updatedCaseDetails = {
            ...caseDetails, isReqforDoc: e.target.checked,
        };
        dispatch({
            type: 'SET_CASE_DETAILS',
            payload: updatedCaseDetails,
        });
        form.setFieldsValue({
            isReqforDoc: e.target.checked
        });
    }
    const handleTemplateChange = useCallback((templateId) => {
        const selectedTemplate = templateLU.find((t) => t.id === templateId);
        if (selectedTemplate) {
            const updatedCaseDetails = {
                ...caseDetails,
                remarks: selectedTemplate.remarks || "",
                selectedTemplateName: selectedTemplate.templateName,
            };
            dispatch({
                type: "SET_CASE_DETAILS",
                payload: updatedCaseDetails,
            });
            form.setFieldsValue({
                remarks: selectedTemplate.remarks || "",
            });
        }
    }, [templateLU, caseDetails, dispatch, form]);
    const handleRemarkChange = useCallback((e) => {
        const { value } = e.target;
        form.setFieldsValue({
            remarks: value
        });
    }, [form])
    const handleSubmit = useCallback(async () => {
        const values = form.getFieldsValue();
        dispatch({ type: "SET_BTN_LOADER", payload: true });
        dispatch({ type: "SET_ERROR", payload: null });
        try {
            const postData = {
                id: caseDetails?.id,
                caseNumber: caseDetails?.caseNumber,
                caseTitle: caseDetails?.caseTitle,
                appName: caseDetails?.appName,
                assignedTo: values?.assignedTo?.map?.((item) => ({
                    assignedToIds: item.assignedToIds?.join(","),
                    id: item.id || uuidv4(),
                    assignedRemarks: item.assignedRemarks?.trim(),
                    recordStatus:
                        "recordStatus" in item ? item.recordStatus : "Added",
                })),
                commonModel: caseDetails?.commonModel,
                customerId: caseDetails?.customerId,
                remarks: values?.remarks || caseDetails?.remarks,
                state: values?.state || caseDetails?.state,
                createdDate: caseDetails?.createdDate,
                createdBy: caseDetails?.createdBy,
                modifiedDate: new Date(),
                modifiedBy: userProfile?.currentUser?.userName,
                caseDetails: state?.updatedDocuments,
                templateName: values?.templateName,
                customerCaseTitle: values?.customerCaseTitle,
                isCustomerDocument: true,
                type: caseDetails?.type,
                isReqforDoc: values?.isReqforDoc,
                reason: values?.reason || null,
                typeId: caseDetails?.typeId,
                note: values?.note,
                isAdmin: caseDetails?.isAdmin,
            };
            const response = await apicallsForCases.createCase(postData, "update");
            if (response.ok) {
                window.scrollTo(0, 0);
                handleCancel();
                message.success("Cases details updated successfully");
            } else {
                window.scrollTo(0, 0);
                dispatch({
                    type: "SET_ERROR",
                    payload: isErrorMessage(response?.data),
                });
            }
        } catch (error) {
            window.scrollTo(0, 0);
            dispatch({
                type: "SET_ERROR",
                payload: error.message,
            });
        } finally {
            dispatch({ type: "SET_BTN_LOADER", payload: false });
        }
    }, [form, caseDetails, userProfile, state, dispatch, apicallsForCases, handleCancel,]);


    const updateCaseDetails = useCallback((updatedState) => {
        dispatch({
            type: 'SET_CASE_STATE',
            payload: updatedState
        })
    }, [dispatch])
    const closeError = useCallback(() => {
        dispatch({ type: 'SET_ERROR', payload: null })
    }, [dispatch])
    return (
        <div className=''>
            <HeaderComponent breadCrumbList={breadCrumbList} />
            {error && <div className="mt-3"> <ErrorMessage msg={error} onClose={closeError} /></div>}
            {loader && <Loader />}
            {!loader && <Form form={form} autoComplete="off" className="" onFinish={handleSubmit}>
                <Details caseDetails={caseDetails} caseStateLu={caseStateLu} form={form} updateCaseDetails={updateCaseDetails} />
                <CaseInfo caseDetails={caseDetails} />
                {caseDetails?.isAdmin && <div className='border border-StrokeColor rounded-5 p-4 mt-7 grid md:grid-cols-2 gap-4'>
                    <div className='custom-user-input'>
                        <Form.Item
                            className="custom-input mb-0"
                            name="note"
                            label='Note'
                            rules={[
                                {
                                    required: true, message: 'Is required'
                                },
                                {
                                    whitespace: true
                                },
                                {
                                    validator: validateContentRules
                                }
                            ]}
                        >
                            <TextArea rows='3' placeholder='Write Note' className="!bg-transparent rounded-5" value={caseDetails.note} onChange={handleRemarkChange} maxLength={400} />
                        </Form.Item>
                    </div>
                </div>}
                {!caseDetails?.isAdmin && <><Form.List
                    name="assignedTo"
                >
                    {(fields, { add, remove }) => {
                        const isCaseStateFinal = caseDetails?.state === 'Rejected' || caseDetails?.state === 'Approved';

                        return (
                            <>
                                {fields?.map?.(({ key, name, ...restField }, index) => {
                                    const isLastItem = index === fields.length - 1;
                                    const canDelete = fields.length > 1;

                                    const addTooltipTitle = isCaseStateFinal ? "Action not allowed" : "Add New Assignee";
                                    const iconDisabledClass = isCaseStateFinal ? 'cursor-not-allowed' : '';

                                    return (
                                        <div className="grid md:grid-cols-5 gap-3 border border-StrokeColor rounded-5 p-4 mt-7 items-center" key={key}>
                                            <div className='md:col-span-4 grid md:grid-cols-2 gap-4'>
                                                <div className="custom-user-input custom-user-select">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'assignedToIds']}
                                                        className=" custom-input mb-0"
                                                        rules={[{ required: true, message: 'Is required' }]}
                                                        label="Assigned To"
                                                        colon={false}
                                                    >
                                                        <SelectInput
                                                            showSearch={false}
                                                            allowClear={false}
                                                            multiple={true}
                                                            label={false}
                                                            fieldName="Assigned To"
                                                            optionValue="id"
                                                            optionLabel="assignedTo"
                                                            options={adminsData}
                                                            customClass="!pt-0 !rounded-5"
                                                            disabled={isCaseStateFinal}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div className="custom-user-input custom-user-select">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'assignedRemarks']}
                                                        className="custom-input mb-0"
                                                        label="Assigned Remarks"
                                                        colon={false}
                                                        rules={[
                                                            {
                                                                whitespace: true
                                                            }
                                                        ]}
                                                    >
                                                        <TextArea
                                                            rows="2"
                                                            defaultValue=""
                                                            maxLength={200}
                                                            className="!bg-transparent rounded-5"
                                                            placeholder='Write Remarks'
                                                            disabled={isCaseStateFinal}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='flex justify-end'>
                                                {isLastItem && (
                                                    <Tooltip title={addTooltipTitle}>
                                                        <span
                                                            className={`icon addrow-icon cursor-pointer mr-4 ${iconDisabledClass}`}
                                                            onClick={() => {
                                                                if (!isCaseStateFinal) {
                                                                    addRow(add);
                                                                }
                                                            }}
                                                            disabled={isCaseStateFinal}
                                                        >
                                                        </span>
                                                    </Tooltip>
                                                )}
                                                {canDelete && (
                                                    <div>
                                                        <Tooltip title={'Delete Assignee'}>
                                                            <span
                                                                className={`icon deleterow-icon cursor-pointer mr-4 ${iconDisabledClass}`}
                                                                disabled={isCaseStateFinal}
                                                                onClick={() => {
                                                                    if (!isCaseStateFinal) {
                                                                        confirm({
                                                                            content: (
                                                                                <div className="!text-base !text-subTextColor py-5">
                                                                                    Are you sure do you want to Delete Assignee?
                                                                                </div>
                                                                            ),
                                                                            title: (
                                                                                <div className="!text-base !text-titleColor">
                                                                                    Delete Assignee ?
                                                                                </div>
                                                                            ),
                                                                            okButtonProps: {
                                                                                loading: isDeleted,
                                                                                className: "primary-btn",
                                                                            },
                                                                            cancelButtonProps: {
                                                                                className: " cancel-btn",
                                                                            },
                                                                            onOk: () => deleteRow(index, remove),
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        );
                    }}
                </Form.List>
                    <div className='flex gap-2 items-center mt-7'>
                        <Form.Item name='isReqforDoc' className="mb-0">
                            <label className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    defaultChecked={caseDetails?.isReqforDoc}
                                    value={caseDetails?.isReqforDoc}
                                    onChange={handleToggle}
                                    disabled={caseDetails?.state === 'Rejected' || caseDetails?.state === 'Approved'}
                                />
                                <span></span>
                            </label>
                        </Form.Item>
                        <span className='text-whiteText text-base font-normal'>Request for document</span>
                    </div>
                    {caseDetails?.isReqforDoc && <div className="border border-StrokeColor rounded-5 p-4 mt-1">
                        <div>
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="custom-user-input">
                                    <Form.Item name="customerCaseTitle" className="custom-input mb-0"
                                        label="Assigned Remarks"
                                        required
                                        colon={false}
                                        rules={[{ required: true, message: 'Is required' }]}
                                    >
                                        <Input
                                            className="w-full appearance-none "
                                            placeholder="Customer Case Title"
                                            fieldName="Customer Case Title"
                                            maxLength={50}
                                            disabled={caseDetails?.state === 'Rejected' || caseDetails?.state === 'Approved'}
                                        />
                                    </Form.Item>
                                </div>
                                <div className="custom-user-input">
                                    <Form.Item name="templateName"
                                        label="Use Template"
                                        className="custom-input mb-0"
                                        colon={false}
                                    >
                                        <SelectInput
                                            customClass="!pt-0 !rounded-5"
                                            showSearch={false}
                                            allowClear={false}
                                            placeholder="Use Template"
                                            fieldName="Use Template"
                                            options={templateLU}
                                            onChange={handleTemplateChange}
                                            optionValue="id"
                                            optionLabel="templateName"
                                        // disabled={caseDetails?.state === 'Rejected' || caseDetails?.state === 'Approved'}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className=" mb-3">
                                <span className="font-normal text-sm text-labelGrey capitalize">
                                    Documents
                                </span>
                                <span className="font-normal text-sm text-labelGrey capitalize">
                                    {" "}
                                    (When you select documents customers will be notified to submit this document)
                                </span>
                            </div>
                            <div className='grid grid-cols-1 xl:grid-cols-2 md:grid-cols-2 mt-1 gap-3'>
                                {state?.updatedDocuments?.map?.((item) => (
                                    <div className='flex items-center gap-2' key={item.id}>
                                        <label className="custom-checkbox">
                                            <Form.Item name={`checkbox-${item.documentName}`} className="mb-0">
                                                <input
                                                    type="checkbox"
                                                    checked={item.isChecked}
                                                    onChange={() => handleCheckboxChange(item.id)}
                                                    disabled={caseDetails?.state === 'Rejected' || caseDetails?.state === 'Approved'}
                                                />
                                                <span></span>
                                            </Form.Item>
                                        </label>
                                        <p className='text-whiteText text-base font-normal'>{item.documentName}</p>
                                    </div>
                                ))}
                            </div>
                            <div className='mt-7'>
                                <AuditLogDetails caseDetails={caseDetails} />
                            </div>
                        </div>
                    </div>} </>}
                <div className="mt-5 md:flex justify-end gap-2 space-y-2 md:space-y-0">
                    <Button key="back" type="cancel" className="cancel-btn" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button
                        key="submit"
                        htmlType="submit" type="primary" className="primary-btn" loading={state?.btnLoader}
                        disabled={(caseDetails?.state === 'Rejected' || caseDetails?.state === 'Approved') && caseStateSelect !== 'Reopened'}
                    >
                        Save
                    </Button>
                </div>
            </Form>}
        </div>
    );
};
export default Edit;
